import createIcon from '../../createIcon';

/**
 * @component @name Plagiarism
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQgMkg2QzQuOSAyIDQgMi45IDQgNFYyMEM0IDIxLjEgNC44OSAyMiA1Ljk5IDIySDE4QzE5LjEgMjIgMjAgMjEuMSAyMCAyMFY4TDE0IDJaTTE1LjA0IDE5LjQ1TDEzLjE2IDE3LjU3QzExLjgzIDE4LjI4IDEwLjE1IDE4LjEgOS4wMyAxNi45OEM3LjY2IDE1LjYxIDcuNjYgMTMuNCA5LjAzIDEyLjAzQzEwLjQgMTAuNjYgMTIuNjEgMTAuNjYgMTMuOTggMTIuMDNDMTUuMSAxMy4xNSAxNS4yOSAxNC44MyAxNC41NyAxNi4xNkwxNi40NSAxOC4wNEwxNS4wNCAxOS40NVpNMTMgOVYzLjVMMTguNSA5SDEzWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTExLjUgMTZDMTIuMzI4NCAxNiAxMyAxNS4zMjg0IDEzIDE0LjVDMTMgMTMuNjcxNiAxMi4zMjg0IDEzIDExLjUgMTNDMTAuNjcxNiAxMyAxMCAxMy42NzE2IDEwIDE0LjVDMTAgMTUuMzI4NCAxMC42NzE2IDE2IDExLjUgMTZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Plagiarism = createIcon('Plagiarism', [
  [
    'path',
    {
      d: 'M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM15.04 19.45L13.16 17.57C11.83 18.28 10.15 18.1 9.03 16.98C7.66 15.61 7.66 13.4 9.03 12.03C10.4 10.66 12.61 10.66 13.98 12.03C15.1 13.15 15.29 14.83 14.57 16.16L16.45 18.04L15.04 19.45ZM13 9V3.5L18.5 9H13Z',
      key: '1r1b22',
    },
  ],
  [
    'path',
    {
      d: 'M11.5 16C12.3284 16 13 15.3284 13 14.5C13 13.6716 12.3284 13 11.5 13C10.6716 13 10 13.6716 10 14.5C10 15.3284 10.6716 16 11.5 16Z',
      key: '2wmnjd',
    },
  ],
]);

export default Plagiarism;
